// Add your custom JS here.
import Modal from "bootstrap/js/dist/modal";

Fancybox.bind("[data-fancybox]");

(function ($) {
  "use strict";

  $(document).ready(function () {
    var myModal = new Modal(document.getElementById("gfoPromoModal"));
    window.setTimeout(function () {
      myModal.show();
    }, 500);
  });

  window.initDivisionMap = function () {
    if ($("#division-map").length && typeof google !== "undefined") {
      var map = new google.maps.Map(document.getElementById("division-map"), {
        zoom: 10,
        center: { lat: 0, lng: 0 },
      });

      var bounds = new google.maps.LatLngBounds();
      var infoWindow = new google.maps.InfoWindow(
        {
            maxHeight: 500
        }
      );

      if (
        typeof divisionMapData !== "undefined" &&
        divisionMapData.communities
      ) {
        divisionMapData.communities.forEach(function (community) {
          var marker = new google.maps.Marker({
            position: {
              lat: parseFloat(community.lat),
              lng: parseFloat(community.lng),
            },
            map: map,
            title: community.title,
            icon: divisionMapData.markerIcon,
          });

          bounds.extend(marker.getPosition());

          google.maps.event.addListener(marker, "click", function () {
            var content =
              '<div class="map-info-window">' +
              '<div class="block">' +
                '<div class="row">' +
                    '<div class="col-md-3">' +
                        '<img src="' +
                        community.image +
                        '" alt="' +
                        community.title +
                        '">' +
                    "</div>" +
                    '<div class="col-md-9">' +
                        '<a href="' + community.link + '">' +
                        "<h4>" +
                        community.title +
                        "</h4>" +
                        '</a>' + 
                        '<h5 class="map-info-window__address">' + community.address + '</h5>' +
                        "<p>" +
                        community.excerpt +
                        "</p>" +
                        "<div class='row fw-bold'>" +
                        "<div class='col-md'>" + community.ranges.minBedrooms + " - " + community.ranges.maxBedrooms + " bds" + "</div>" +
                        "<div class='col-md'>" + community.ranges.minBathrooms + " - " + community.ranges.maxBathrooms + " ba" + "</div>" +
                        "<div class='col-md'>" + community.ranges.minSqFt + " - " + community.ranges.maxSqFt + " sq. ft." + "</div>" +
                    "</div>" +
                    "</div>" +
                "</div>" +

              "</div>" +
              "</div>";

            infoWindow.setContent(content);
            infoWindow.open(map, marker);
          });
        });

        map.fitBounds(bounds);
      }
    }
  };

  $(document).ready(function () {
    // Call initDivisionMap after a short delay to ensure Google Maps API is loaded
    setTimeout(function () {
      window.initDivisionMap();
    }, 1000);
  });

  $('#popup-form-btn').click(function(){
    $('#form-popup').css('display', 'block');
  });

  $('#form-popup i').click(function(){
    $('#form-popup').css('display', 'none');
  });

  $(document).ready(function () {
    $(".accordion-title").click(function () {
      $(this)
        .toggleClass("active")
        .next(".accordion-tab-content")
        .slideToggle()
        .parent()
        .siblings()
        .find(".accordion-tab-content")
        .slideUp()
        .prev()
        .removeClass("active");
    });
  });

  $(window).scroll(function(){
    if ($(this).scrollTop() > 50) {
       $('#main-nav').addClass('sticky');
    } else {
       $('#main-nav').removeClass('sticky');
    }
  });

})(jQuery);